<template>
  <div class="dialog-motion" :style="style">
    <slot />
  </div>
</template>
<script setup lang="ts">
interface Props {
  stiffness: number;
  damping: number;
  delay: number;
  x?: number;
  y?: number;
  scale?: number;
  rotation?: number;
}
const props = defineProps({
  stiffness: null,
  damping: null,
  delay: null,
  x: { default: 0 },
  y: { default: 0 },
  scale: { default: 0 },
  rotation: { default: 0 }
});

const { effect: xEffect, value: xValue } = useSpring(props.x, {
  stiffness: props.stiffness,
  damping: props.damping,
  mass: 1,
});
const { effect: yEffect, value: yValue } = useSpring(props.y, {
  stiffness: props.stiffness,
  damping: props.damping,
  mass: 1,
});
const { effect: scaleEffect, value: scaleValue } = useSpring(props.scale, {
  stiffness: props.stiffness,
  damping: props.damping,
  mass: 1,
});
const { effect: rotationEffect, value: rotationValue } = useSpring(
  props.rotation,
  {
    stiffness: props.stiffness,
    damping: props.damping,
    mass: 1,
  }
);

const style = computed(() => {
  return {
    transform: `translateX(${xEffect.value}px) translateY(${yEffect.value}px) rotate(${rotationEffect.value}deg) scale(${scaleEffect.value})`,
  };
});

const start = () => {
  xValue.value = 0;
  yValue.value = 0;
  scaleValue.value = 1;
  rotationValue.value = 0;
};

let timeout;

onMounted(() => {
  timeout = setTimeout(() => {
    start();
  }, props.delay * 1000);
});

onUnmounted(() => {
  clearTimeout(timeout);
});
</script>
<style lang="scss" scoped>
.dialog-motion {
  display: flex;
  justify-content: center;
  transform-origin: 50%;
}
</style>
